// App.js
import React, { useRef } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Hero from './components/Hero';
import Kuda from './components/Kuda';
import About from './components/About';
import OurServices from './components/OurServices';
import OurGallery from './components/OurGallery';
import OurTeam from './components/OurTeam';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Information from './components/Information';
import Footer from './components/Footer';

function App() {
  const targetRef = useRef(null);

  return (
    <>
      <Router>
        <Kuda />
        <Hero targetRef={targetRef} />
        <About />
        <OurServices />
        <OurGallery />
        <OurTeam />
        <Testimonials />
        <Contact />
        <Information />
        <Footer />
      </Router>
      <div id="scroll-down-target" ref={targetRef}></div>
    </>
  );
}

export default App;





// // App.js
// import React, { useRef } from 'react';
// import { Link as ScrollLink } from 'react-scroll';

// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import Hero from './components/Hero';
// import Kuda from './components/Kuda';
// import About from './components/About';
// import OurServices from './components/OurServices';
// import OurGallery from './components/OurGallery';
// import OurTeam from './components/OurTeam';
// import Testimonials from './components/Testimonials';
// import Contact from './components/Contact';
// import Information from './components/Information';
// import Footer from './components/Footer';

// function App() {
//   const targetRef = useRef(null);

//   const ScrollDownAnchor = () => {
//     const handleMouseEnter = () => {
//       const targetElement = targetRef.current;
//       if (targetElement) {
//         targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
//       }
//     };

//     return (
//       <a href="#scroll-down-target" onMouseEnter={handleMouseEnter}>
//         Scroll Down
//       </a>
//     );
//   };

//   return (
//     <>
//       <Router>
//         <Kuda />
//         <Hero targetRef={targetRef} ScrollDownAnchor={ScrollDownAnchor} />
//         <About />
//         <OurServices />
//         <OurGallery />
//         <OurTeam />
//         <Testimonials />
//         <Contact />
//         <Information />
//         <Footer />
//       </Router>
//       <div id="scroll-down-target" ref={targetRef}></div>
//     </>
//   );
// }

// export default App;








// import React, { useRef } from 'react';
// import { Link as ScrollLink } from 'react-scroll';

// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import Hero from './components/Hero';
// import Kuda from './components/Kuda';
// import About from './components/About';
// import OurServices from './components/OurServices';
// import OurGallery from './components/OurGallery';
// import OurTeam from './components/OurTeam';
// import Testimonials from './components/Testimonials';
// import Contact from './components/Contact';
// import Information from './components/Information';
// import Footer from './components/Footer';

// function App() {
//   const targetRef = useRef(null);

//   const ScrollDownAnchor = () => {
//     const handleMouseEnter = () => {
//       const targetElement = targetRef.current;
//       if (targetElement) {
//         targetElement.scrollIntoView({ behavior: 'smooth' });
//       }
//     };

//     return (
//       <a href="#scroll-down-target" onMouseEnter={handleMouseEnter}>
//         Scroll Down
//       </a>
//     );
//   };

//   return (
//     <>
//       <Router>
//         <Kuda />
//         <Hero targetRef={targetRef} ScrollDownAnchor={ScrollDownAnchor} />
//         <About />
//         <OurServices />
//         <OurGallery />
//         <OurTeam />
//         <Testimonials />
//         <Contact />
//         <Information />
//         <Footer />
//       </Router>
//       <div id="scroll-down-target" ref={targetRef}></div>

//     </>
//   );
// }

// export default App;











// import './App.css';
// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import Hero from './components/Hero';
// import Kuda from './components/Kuda'
// import About from './components/About';
// import OurServices from './components/OurServices';
// import OurGallery from './components/OurGallery';
// import OurTeam from './components/OurTeam';
// import Testimonials from './components/Testimonials';
// import Contact from './components/Contact';
// import Information from './components/Information';
// import Footer from './components/Footer';

// function App() {
//   return (
//     <>
//         <Router>

//     <Kuda/>
//     <Hero/>
//     <About/>
//     <OurServices/>
//     <OurGallery/>
//     <OurTeam/>
//     <Testimonials/>
//     <Contact/>
//     <Information/>
//     <Footer/>
//     </Router>

//     </>
//   );
// }

// export default App;
